/**
 * "Moved to Finished. Today's lesson hasn't changed." -- said on the student's
 * lesson list after they finish a lesson from Incomplete in No expectation mode
 * (Alloy, student v7).
 *
 * The tutor knows the student finished it; the list knows whether the server
 * agrees. So the tutor leaves the lesson's id in the router state of its way
 * back to the list (`withMovedToFinished`), and the list says it only once its
 * schedule shows that lesson in Finished.
 */
export const MOVED_TO_FINISHED_NOTICE =
  "Moved to Finished. Today's lesson hasn't changed.";

/** The router state the tutor leaves for the lesson list. */
export type LessonListState = { movedToFinishedLessonId?: number };

type Navigate = (
  route: string,
  options?: { replace?: boolean; state?: unknown },
) => void;

/** `navigate`, carrying the finished lesson's id to the list it goes to. */
export const withMovedToFinished =
  (navigate: Navigate, lessonId: number): Navigate =>
  (route, options) =>
    navigate(route, {
      ...options,
      state: { movedToFinishedLessonId: lessonId } satisfies LessonListState,
    });

/** The finished lesson's id, from router state that may be anything. */
export const movedToFinishedLessonId = (state: unknown): number | null => {
  const id = (state as LessonListState | null)?.movedToFinishedLessonId;
  return typeof id === "number" && Number.isFinite(id) ? id : null;
};
